import { useMutation } from '@apollo/client';
import { useTranslation } from 'react-i18next';
import { useNotifications, type ApiOptions } from '../helpers';
import { RenameDesignTagDocument } from './rename.generated';

export const useRenameDesignTag = (options: ApiOptions<typeof RenameDesignTagDocument> = {}) => {
  const { t } = useTranslation();
  return useMutation(RenameDesignTagDocument, {
    ...useNotifications(RenameDesignTagDocument, {
      failure: t('api.design_tags.rename_error'),
      success: t('api.design_tags.rename_success'),
    }),
    ...options,
  });
};
